import React from 'react';
import FromTo from 'shared/assets/images/svg/from_to.svg';
import MapBl from 'shared/assets/images/svg/map_bl_md.svg';
import RouteBl from 'shared/assets/images/svg/route_bl_md.svg';
import Input from 'shared/component/inputFields';
import TextArea from 'shared/component/textArea';
import FooterAction from 'customer/orders/create-order/component/footerAction';
import IconDate from 'shared/assets/images/svg/date_bl_md.svg'
import IconRoute from 'shared/assets/images/svg/route_bl_md.svg'
import IconMap from 'shared/assets/images/svg/map_bl_md.svg'
import { Tooltip } from '@mui/material';
import { useCreateOrder } from "customer/orders/create-order/create-order.service";


const Summary = (props) => {
    const {orderData} = useCreateOrder()
    return (
        <div className='myorder summary'>
            <div className='container '>
                <div className='steps'>
                    <Tooltip title="NEW ORDER" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="SHIPPING DETAILS" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="FROM DETAILS" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="TO DETAILS" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="DESTINATIONS" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="SUMMARY" arrow>
                        <span className='indicator active'></span>
                    </Tooltip>
                    <Tooltip title="PENDING" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                </div>
                <div className='summeryHeader'>
                    <div className='box-step'>
                        <p className='title'>City Name</p>
                        <img className='icon' src={FromTo} alt="IconDate" />
                        <p className='title'>City Name</p>
                    </div>

                    <div className='box-step'>
                        <img className='icon' src={IconDate} alt="IconRoute" />
                        <p className='title active'>10/24/2021 - 02:00 PM</p>
                    </div>

                    <div className='box-step'>
                        <img className='icon' src={IconRoute} alt="IconMap" />
                        <p className='title active'>3 STOPS INCLUDED </p>
                    </div>

                    <div className='box-step'> 
                        <img className='icon' src={IconMap} alt="IconMap" />
                        <p className='title active'>External</p>
                    </div>

                </div>
                <div className='row'>
                    <div className='col-md-8'>
                        <div className='summary-details'>
                            <div className='details'>
                                <h1 className='title'>Shipping Details</h1>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Responsible Person:" value="Ahmed Ali" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Vehicle Type:" value="Truck12" readonly />
                                    </div>
                                </div>
                            </div>

                            <div className='details'>
                                <h1 className='title'>Goods Details</h1>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Goods Type:" value="Lorem Goods Type" readonly />
                                    </div>
                                    <div className='col-md-4'>
                                        <Input type="text" label="Goods Wight:" value="750" readonly />
                                    </div>
                                    <div className='col-md-2'>
                                        <Input type="text" label="Unit:" value="Kgm" readonly />
                                    </div>
                                    <div className='col-md-12'>
                                        <TextArea label="Goods Discerption:" value="Sed Ut Perspiciatis Unde Omnis Iste Natus Error Sit Voluptatem Accusantium Doloremque Laudantium, Totam Rem Aperiam, Eaque Ipsa Quae Ab Illo Inventore Veritatis Et Quasi Architecto Beatae Vitae Dicta Sunt Explicabo" readonly />
                                    </div>
                                </div>
                            </div>
                            <div className='details'>
                                <h1 className='title'>From Details <span>(Pickup Point)</span></h1>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="From:" value="City Name Goes Here" readonly />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Contact Person:" value="Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Phone:" value="+961 123456789" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Address:" value="Address Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Location:" value="Location Details Goes Here" readonly />
                                    </div>
                                    <div className='col-md-12'>
                                        <TextArea label="Address Details:" value="Sed Ut Perspiciatis Unde Omnis Iste Natus Error Sit Voluptatem Accusantium Doloremque Laudantium, Totam Rem Aperiam, Eaque Ipsa Quae Ab Illo Inventore Veritatis Et Quasi Architecto Beatae Vitae Dicta Sunt Explicabo" readonly />
                                    </div>
                                </div>
                            </div>
                            <div className='details'>
                                <h1 className='title'>To Details <span>(Delivery Point)</span></h1>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="to:" value="City Name Goes Here" readonly />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Contact Person:" value="Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Phone:" value="+961 123456789" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Address:" value="Address Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Location:" value="Location Details Goes Here" readonly />
                                    </div>
                                    <div className='col-md-12'>
                                        <TextArea label="Address Details:" value="Sed Ut Perspiciatis Unde Omnis Iste Natus Error Sit Voluptatem Accusantium Doloremque Laudantium, Totam Rem Aperiam, Eaque Ipsa Quae Ab Illo Inventore Veritatis Et Quasi Architecto Beatae Vitae Dicta Sunt Explicabo" readonly />
                                    </div>
                                </div>
                            </div>
                            <div className='details'>
                                <h1 className='title'>Stop No. 1</h1>
                                <div className='row'>
                                    <div className='col-md-6'>
                                        <Input type="text" label="From:" value="City Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="To:" value="City Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Contact Person:" value="Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Phone:" value="+961 123456789" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Address:" value="Address Name Goes Here" readonly />
                                    </div>
                                    <div className='col-md-6'>
                                        <Input type="text" label="Location:" value="Location Details Goes Here" readonly />
                                    </div>
                                    <div className='col-md-12'>
                                        <TextArea label="Address Details:" readonly value="Sed Ut Perspiciatis Unde Omnis Iste Natus Error Sit Voluptatem Accusantium Doloremque Laudantium, Totam Rem Aperiam, Eaque Ipsa Quae Ab Illo Inventore Veritatis Et Quasi Architecto Beatae Vitae Dicta Sunt Explicabo" />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='col-md-4'>
                        <div className='summary-info'>
                            <div className='box-from'>
                                <div className='box-header'>
                                    <div className='from'>
                                        <span>from</span>
                                        <h2>City Name</h2>
                                    </div>
                                    <div className='to'>
                                        <span>tp</span>
                                        <h2>City Name</h2>
                                    </div>
                                </div>
                                <div className='inf0'>
                                    <img src={IconDate} alt='IconDate' />
                                    <h3>10/24/2021 - 02:00 PM</h3>
                                </div>
                                <div className='inf0'>
                                    <img src={RouteBl} alt='RouteBl' />
                                    <h3>3 STOPS INCLUDED</h3>
                                </div>

                                <div className='inf0'>
                                    <img src={MapBl} alt='MapBl' />
                                    <h3>External</h3>
                                </div>
                            </div>
                            <div className='box-cost'>
                                <h1 className='title'>SUMMARY</h1>
                                <div className='cost-info dimmed'>
                                    <p>Total</p>
                                    <span>2,765</span>
                                </div>
                                <div className='cost-info dimmed'>
                                    <p>Stop Cost</p>
                                    <span>3x150</span>
                                </div>
                                <div className='cost-info dimmed'>
                                    <p>Discount</p>
                                    <span>-150</span>
                                </div>
                                <hr className='hr dotted'/>
                                <div className='cost-info dark'>
                                    <p>Subtotal</p>
                                    <span className='bold'>3215.32</span>
                                </div>
                                <div className='cost-info dimmed'>
                                    <p>15% VAT</p>
                                    <span>450</span>
                                </div>
                                <hr className='hr dotted' />
                                <div className='cost-info dark'>
                                    <p>Net Total</p>
                                    <span  className='bold'>3600</span>
                                </div>
                                <div className='cost-info dimmed'>
                                    <p>Outstanding Amounts</p>
                                    <span>150</span>
                                </div>
                                <hr className='hr' />
                                <div className='cost-info dark amount'>
                                    <p>Invoice Amount</p>
                                    <span>5000.00 <span>EGP</span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='action'>
                <div className='container'>
                    <button type='button' className='btn-border-blue' onClick={props.previousStep}>Back</button>
                    <button type='submit' className='btn-blue'>Process</button>
                </div>
            </div>
        </div>
    )
}

export default Summary

